// Invoke 'strict' JavaScript mode
'use strict';
var request = require('request');

module.exports = {
	load: function(url, callback){
		var $ = this;
		request({
			url: "https://is.gd/create.php?format=simple&url="+url,
			json: true
		}, function (error, response, body) {
			if (!error && response.statusCode == 200) {
				callback(null, body);
			}else {
				this.emit('error', new Error('Bad status code'));
			}
		});
	},
	short: function(url, callback){
		return this.load(url, callback);
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/node-url-shortener/src/urlshortner.js
// module id = 1100
// module chunks = 0